/**
 * Usonian CSS > Elements > Page
 */

import { css } from 'styled-components';
import { colors, globals } from 'shared/styles/settings';

export default css`
  html {
    background-color: white;
    color: ${colors.midnightGrey};
    font-family: Nunito, system, BlinkMacSystemFont, sans-serif !important;
    font-size: ${globals.baseFontSize};
    -webkit-font-smoothing: antialiased;
    height: 100%;
    line-height: ${globals.baseLineHeight};
    min-height: 100%;
    overflow-y: hidden;
  }

  body {
    font-family: Nunito, system, BlinkMacSystemFont, sans-serif !important;
    height: 100%;
    position: relative;
    color: inherit !important;
  }
`;
